import { User as FirebaseUser } from 'firebase/auth';
import { getDocument } from '@/shared/services/firebase';
import { User } from '@/features/users';

export const verifyUser = async (user: FirebaseUser): Promise<boolean> => {
	try {
		if (user?.uid) {
			const userDoc = await getDocument<User>(user.uid, 'users');
			return userDoc != null;
		}
		return false;
	} catch {
		return false;
	}
};
